import { render, staticRenderFns } from "./TrainingPage.vue?vue&type=template&id=3a620954&scoped=true&"
import script from "./TrainingPage.vue?vue&type=script&lang=js&"
export * from "./TrainingPage.vue?vue&type=script&lang=js&"
import style0 from "./TrainingPage.vue?vue&type=style&index=0&id=3a620954&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a620954",
  null
  
)

export default component.exports